import { AxiosError } from 'axios';
import { axiosRequest } from './instance';
import { TenantId } from './tenants/Tenant';

// region Branded ID
declare const _tenantCriteriaWeightId: unique symbol;
export type TenantCriteriaWeightId = string & {
  [_tenantCriteriaWeightId]: 'TenantCriteriaWeightId';
};
// endregion

export type CriteriaName =
  | 'SpecializationMatch'
  | 'MentorVotes'
  | 'NumberOfMentorAssignments'
  | 'EmbeddingMatch'
  | 'PreviousMatchOffer'
  | 'AssignmentHistory'
  | 'ExistingAssignment'
  | 'MentorManagementRequests'
  | 'GeographicalProximity';

export interface TenantCriteriaWeight {
  id: TenantCriteriaWeightId;
  tenantId: TenantId;
  criteriaName: CriteriaName;
  weight: number;
}

export type TenantCriteriaWeightPayload =
  | TenantCriteriaWeight
  | Pick<TenantCriteriaWeight, 'criteriaName' | 'weight'>;

const matchingWeightsAPI = {
  async getWeights(): Promise<TenantCriteriaWeight[]> {
    try {
      const res = await axiosRequest.get<TenantCriteriaWeight[]>({
        url: '/tenants/advanced-matching/weights',
        credentials: true,
      });
      return res.data;
    } catch (e: unknown) {
      const error = e as AxiosError;
      if (error.response?.status === 404) {
        return [];
      }
      throw e;
    }
  },

  async updateWeights(
    weights: TenantCriteriaWeightPayload[],
  ): Promise<TenantCriteriaWeight[]> {
    const res = await axiosRequest.put<TenantCriteriaWeight[]>({
      url: '/tenants/advanced-matching/weights',
      data: weights,
      credentials: true,
    });
    return res.data;
  },
};

export default matchingWeightsAPI;
